import React, { Component } from 'react';
import earthIcon from 'images/earth-icon.svg';
import facebookIcon from 'images/facebook-icon.svg';
import instagramIcon from 'images/instagram-icon.svg';

const MAP_ICONS = {
  facebook: facebookIcon,
  instagram: instagramIcon,
  youtube: earthIcon,
  other: earthIcon,
};

class CreatedTextLink extends Component {
  get iconSrc() {
    const {
      link: { url },
    } = this.props;

    if (!url) return MAP_ICONS.other;

    const mockLink = document.createElement('a');
    mockLink.href = url;

    switch (mockLink.hostname) {
      case 'facebook.com':
        return MAP_ICONS.facebook;
      case 'instagram.com':
        return MAP_ICONS.instagram;
      case 'youtube.com':
        return MAP_ICONS.youtube;
      default:
        return MAP_ICONS.other;
    }
  }

  render() {
    return (
      <div className="link-itm__col">
        <div className="link-itm__descr">
          <div className="link-itm__icon">
            <img src={this.iconSrc} alt="" />
          </div>
          <div className="link-itm__text">{this.props.link.name}</div>
        </div>
      </div>
    );
  }
}

export default CreatedTextLink;



// WEBPACK FOOTER //
// ./src/components/CreatedTextLink/CreatedTextLink.js